import React from "react"
import classNames from "classnames"
import { ToastContainer } from "react-toastify"

import Link from "components/Link"
import NavLink from "components/NavLink"

import Logo from "components/Logo"
import SearchField from "components/SearchField"

import "./Header.sass"
import { useSelector } from "react-redux"
import ProfileFetcher from "pages/ProfileFetcher"

function Avatar() {
  const { entry: profile, isLoaded } = useSelector((state) => state.profile)

  if (!isLoaded) return <ProfileFetcher />

  const { first_name = "", last_name = "" } = profile

  if (first_name === "" || last_name === "") return false

  return <div className="Avatar">{`${first_name[0]}${last_name[0]}`}</div>
}

const Header = ({
  isCentered,
  isTall,
  isSlim,
  isDetail,
  searchValue,
  className,
}) => {
  const { authenticated } = useSelector((state) => state.app)

  const headerClassName = classNames({
    Header: true,
    [className]: !!className,
    isCentered,
    isTall,
    isSlim,
    isDetail,
  })

  return (
    <header className={headerClassName}>
      <Link to="/">
        <Logo />
      </Link>

      <SearchField searchValue={searchValue} isTall={isTall} />

      <div className="menu">
        <NavLink className="my-garage" to="/moja-garaza/">
          <span className="prefix">Moja&nbsp;</span>garaža
          {authenticated && <Avatar />}
        </NavLink>
      </div>
      <ToastContainer />
    </header>
  )
}

export default Header
